export default function isLoadedFromTeams(): boolean {
  return navigator.userAgent.includes("Teams");
}
